import { render, staticRenderFns } from "./InternalPdfView.vue?vue&type=template&id=727839a1"
import script from "./InternalPdfView.vue?vue&type=script&lang=js"
export * from "./InternalPdfView.vue?vue&type=script&lang=js"
import style0 from "./InternalPdfView.vue?vue&type=style&index=0&id=727839a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports